import { useEffect, useState, useCallback } from "react";
import { isTokenPresent } from "../../utils/cookieHelper";
import fetchTransactions from "../../services/RecentActivity/recentTransactions/recentTransaction.service";
import { useStore } from "../../store/useStore";
import { END_OF_RESPONSE } from "../../services/RecentActivity/recentTransactions/recentTransaction.constants";

const useGetTransactions = (trigger = false) => {
  const [
    fetchNextTransactions,
    setFetchNextTransactions,
  ] = useState(trigger);

  const nextPageToken = useStore(
    state => state.transactionsNextPageToken
  );

  const transactionLoading = useStore(
    state => state.transactionLoading
  );

  const nextPageTimeStamp = useStore(
    state => state.transactionsNextTimeStamp
  );

  useEffect(() => {
    if (!isTokenPresent() || transactionLoading) return;
    if (
      fetchNextTransactions &&
      nextPageToken !== END_OF_RESPONSE
    ) {
      fetchTransactions(nextPageTimeStamp);
      setFetchNextTransactions(false);
    }
  }, [fetchNextTransactions]);

  return { setFetchNextTransactions };
};

export default useGetTransactions;
